import { takeLatest, all, takeEvery } from 'redux-saga/effects';
import { watcherUsersManagerSaga } from '../modules/UserManager/redux/sagas/handleUserManager';
import * as authSagas from '../modules/login/redux/sagas/handleAuth';
import * as authConstants from '../modules/login/redux/constants';
import * as notificationsSagas from '../modules/container/notifications/notificationsRedux/saga';
import * as notificationsConstants from '../modules/container/notifications/notificationsRedux/constant';
import { watcherTenantsSaga } from '../modules/TenantManager/redux/sagas';
import { watcherTenantUsersManagerSaga } from '../modules/TenantManager/detail/UserManager/redux/sagas/handleUserManager';

function* watcherSaga() {
  yield takeEvery(authConstants.LOGIN, authSagas.handleLoginUser);
  yield takeEvery(authConstants.LOGOUT, authSagas.handleLogoutUser);

  yield takeLatest(
    notificationsConstants.FETCH_NOTIFICATIONS_LIST,
    notificationsSagas.handleFetchAllNotifications
  );
  yield takeLatest(
    notificationsConstants.FETCH_NOTIFICATIONS,
    notificationsSagas.handleFetchUnreadNotificationCount
  );
  yield takeLatest(
    notificationsConstants.UPDATE_NOTIFICATION,
    notificationsSagas.handleUpdateNotification
  );
}

export function* rootSaga() {
  yield all([
    watcherSaga(),
    watcherUsersManagerSaga(),
    watcherTenantsSaga(),
    watcherTenantUsersManagerSaga(),
  ]);
}
